import * as React from "react";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type = "text", ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      "h-10 w-full rounded-sm bg-surface border border-border px-3",
      "text-sm text-fg placeholder:text-fg-subtle",
      "focus:outline-none focus:border-accent-dim focus:ring-1 focus:ring-accent-dim/40",
      "disabled:opacity-50 disabled:cursor-not-allowed",
      "transition-colors",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
